module.exports = "/_next/static/images/BerthMorowali-0690c3c15f29f980f7156a2bcef89d80.svg";